import { useCurrentUser } from '@qualio/ui-components';
import { Approver } from '../types';
import { useMemo } from 'react';

export const useCurrentUserFormApproverOrReviewer = (approvers: Approver[], reviewers: Approver[]) => {
  const { company } = useCurrentUser();
  const currentUserCompanyId = (company as any)['usercompany_id'];

  const isCurrentUserApprover = useMemo(
    () =>
      approvers.find(
        (approver) => approver.usercompany_id === currentUserCompanyId && approver.action_status === 'pending',
      ),
    [approvers, currentUserCompanyId],
  );

  const isCurrentUserReviewer = useMemo(
    () =>
      reviewers.find(
        (approver) => approver.usercompany_id === currentUserCompanyId && approver.action_status === 'pending',
      ),
    [reviewers, currentUserCompanyId],
  );

  return {
    isCurrentUserApprover: !!isCurrentUserApprover,
    isCurrentUserReviewer: !!isCurrentUserReviewer,
  };
};
